<ui-form
  [config]="toggleFormConfig"
  [(formValues)]="toggleFormValues"
></ui-form>

<ui-panel
  panelTitle="This is a simple panel with a title. Toggleable = {{!!toggleFormValues().isToggleable}} | Collapsed = {{isCollapsed}}"
  [(collapsed)]="isCollapsed"
  [isToggleable]="!!toggleFormValues().isToggleable">
  <p>
    - This is the panel content <br />
    - Use the checkbox above to toggle collapsibility<br />
    - This example doesn't use a config object, everything is defined in the HTML<br />
    - the isCollapsed variable is bound to the collapsed input/output of the panel
  </p>
</ui-panel>
